import { makeContextModule } from '@cian/react-utils';

import { type IGetOffersByPinResponse } from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

export const {
  Context: { Provider: ListingByPinContextProvider },
  useContext: useListingByPinContext,
} = makeContextModule<IGetOffersByPinResponse>({
  contextName: 'ListingByPinContext',
});
